/**
 * Used in various places to generate a url for different environments
 */
export const createUrl = (slug: string): string =>
  [
    process.env.NEXT_PUBLIC_PROTO || 'https://',
    process.env.NEXT_PUBLIC_HOST || 'miro.com',
    slug,
  ].join('')
